export default {"src":"/_next/static/media/whatsapp.7b90560a.svg","height":512,"width":512};